/***************************************************************************
* ヘッダーの高さ取得 
***************************************************************************/

const getHeaderHeight = () => {
  const header = document.querySelector('.js-header');
  const headerHeight = header.offsetHeight;
  return headerHeight;
}

/***************************************************************************
* スムーススクロール 
***************************************************************************/

// スムーススクロールのセットアップ
const setupSmoothScroll = () => {
  const links = document.querySelectorAll('a[href^="#"]');
  // ページ内リンクをクリックしたときにスムーススクロールを有効にする
  links.forEach((link) => {
    link.addEventListener('click', handleSmoothScroll);
  });
}

// スムーススクロールオプション設定
const smoothScroll = (targetPosition, onComplete) => {
  let offsetValue = 0;
  const marginTop = 30;
  offsetValue = getHeaderHeight() + marginTop;

  // gsapのScrollToPluginでスムーススクロールさせる
  gsap.to(window, {
    duration: 1.2,
    scrollTo: { y: targetPosition, offsetY: offsetValue },
    ease: Power3.easeInOut,
    onComplete: onComplete,
  });
}

// ページ内リンクがクリックされたときの処理
const handleSmoothScroll = (event) => {
  // デフォルト動作のキャンセル
  event.preventDefault();
  // href属性の取得
  const href = event.currentTarget.getAttribute('href');
  // ハッシュを削除
  const removeHash = href.replace('#', '');
  // 対応するID要素を取得
  const target = document.getElementById(removeHash);

  let targetPosition;
  targetPosition = target.getBoundingClientRect().top + window.pageYOffset;

  // スムーススクロールを実行
  smoothScroll(targetPosition);
};

// スムーススクロールのセットアップを実行
setupSmoothScroll();